import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { useThemeSwitch } from "../../../../theme";
import { ThemeName } from "../../../../theme/constants";

export function ThemeSwitcherMenuItem() {
  const { switchToTheme, themeSetting } = useThemeSwitch();

  return (
    <div style={{ padding: "0.75rem 1rem" }}>
      <div style={{ fontSize: "0.875rem", fontWeight: "600", marginBottom: "0.5rem" }}>Theme</div>
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <RadioButton
            inputId="theme-light"
            name="theme"
            value="atlas-light"
            onChange={(e: RadioButtonChangeEvent) => switchToTheme(e.value as ThemeName)}
            checked={themeSetting === "atlas-light"}
          />
          <label htmlFor="theme-light" style={{ cursor: "pointer", fontSize: "0.875rem" }}>
            Light
          </label>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <RadioButton
            inputId="theme-dark"
            name="theme"
            value="atlas-dark"
            onChange={(e: RadioButtonChangeEvent) => switchToTheme(e.value as ThemeName)}
            checked={themeSetting === "atlas-dark"}
          />
          <label htmlFor="theme-dark" style={{ cursor: "pointer", fontSize: "0.875rem" }}>
            Dark
          </label>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <RadioButton
            inputId="theme-system"
            name="theme"
            value="system"
            onChange={(e: RadioButtonChangeEvent) => switchToTheme(e.value as ThemeName)}
            checked={themeSetting === "system"}
          />
          <label htmlFor="theme-system" style={{ cursor: "pointer", fontSize: "0.875rem" }}>
            Auto
          </label>
        </div>
      </div>
    </div>
  );
}
